// extracted by mini-css-extract-plugin
export default {"btn-back":"ButtonBack_btn-back__RFSbi"};